import { i18n, ResourceLanguage } from "i18next";
import { servicesOrchestratorValues } from "@/config/services";
import { getErrorMessage } from "@/lib/flow-logic/getErrorMessage";
import logger from "@/lib/logging/logger";
import en from "../locales/en.json";

export async function getTranslation(language: string): Promise<ResourceLanguage> {
	const projectToken = servicesOrchestratorValues.credentials.simpleLocalizeProjectToken;
	const environment = servicesOrchestratorValues.credentials.simpleLocalizeEnvironment;
	const loadPathWithNamespaces = `https://cdn.simplelocalize.io/${projectToken}/${environment}/${language}`;

	try {
		const response = await fetch(loadPathWithNamespaces, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});
		if (!response.ok) throw new Error(`Failed to fetch translations from SimpleLocalize `);

		const translations = await response.json();

		return translations;
	} catch (error) {
		logger.error("NETWORK", getErrorMessage(error) ?? "Unknown error");
		return en;
	}
}

const setLanguage = (i18nInstance: i18n, lang: string, translations: ResourceLanguage) => {
	i18nInstance.addResourceBundle(lang, "common", translations);
	i18nInstance.changeLanguage(lang);
	document.documentElement.lang = lang;
	sessionStorage.setItem("selectedLanguage", lang);
};

export const updateLocalization = async (i18nInstance: i18n, lang: string) => {
	try {
		const response = await getTranslation(lang);
		setLanguage(i18nInstance, lang, response);
	} catch (e) {
		throw new Error(getErrorMessage(e));
	}
};
